<!--
	回调事件  Click
-->
<template>
	<label class="checkbox" :class="{ disable: disabled }" :status="option.status" @click.prevent.stop="onClick">
		<div class="tableSys-noWidth vaT_E vaM_E">
			<input type="checkbox" v-model="check" :class="disabled ? 'bgDisabeled bdOuter' : 'check-bg-main'" />
			<div class="w105x h105x h105x-lh">
				<div class="ico boxR-light tra-fast" :class="{ bdOuter: check == false || disabled, bgDisabeled: disabled }">
					<div class="checked tra-fast" :class="disabled ? 'bgDisabeled' : 'bgMain'"></div>
					<Icon name="yes" class="h2x w2x fa fa-check tra-fast" :class="disabled ? 'fFail' : 'fWhite'" />
					<!-- <i class="fa fa-check tra-fast" ></i> -->
				</div>
			</div>
			<slot></slot>
			<span class="content pl1x" :class="textStyle" v-html="text"></span>
		</div>
	</label>
</template>
<script>
export default {
	name: "Checkbox",
	props: {
		value: {
			type: Boolean,
			default: false,
		},
		max: {
			type: Number,
		},
		text: {
			type: String,
			default: "",
		},
		data: {
			// 监听的数据，用于判断选中状态
			type: [Object, Array],
		},
		keyMap: {
			type: String,
			default: "check",
		},
		// 传递的下标，多个循环时候使用
		index: {
			type: [Number, String],
		},
		status: {
			type: [Number, String],
			default: null,
		},
		autoFix: {
			// 自动修正逻辑
			type: String,
			default: "", // emptyToAll:全不选自动全选,>1:必须选择1个以上
		},
		triggerClick: {
			// 设置自动更新数据后触发click回调
			type: Boolean,
			default: true,
		},
		disabled: {
			type: Boolean,
			default: false,
		},
		checkObj: {
			type: Object,
		},
		textStyle: {
			// 文本样式的class名
			type: String,
			default: "",
		},
	},
	components: {},
	data() {
		return {
			option: {
				status: this.status,
			},
			check: this.value,
		};
	},
	watch: {
		check(val) {
			// if(this.status==2) val=true;
			// else if(this.status==1||this.status==0) val=false;
			// this.$emit("input",val,this.index>=0? this.index:"all");
			// if(this.triggerClick) this.$emit("Click",val,this.index>=0? this.index:"all", this.checkObj);
			// this.$set(this,"check",val)//this.check=val;
			// trace(this.check)
			if (this.data) this.updateStatus();
		},
		status(val) {
			this.option.status = val;
			if (val == 2) val = true;
			else val = false;
			this.check = val;
			// this.$emit("Click","all");
		},
		value(val) {
			this.check = val;
		},
		data: {
			// 监听数据，更新状态
			deep: true,
			handler: function () {
				this.updateStatus();
			},
		},
	},
	methods: {
		updateStatus: function () {
			// 更新选中状态
			let $this = this,
				res = { yes: 0, max: 0 };
			// if (this.keyMap) {
			// 	$.each(this.data, function () {
			// 		// this[$this.keyMap]
			// 	})
			// }
			// else {
			$.each(this.data, (index, val) => {
				if (val === true || val[this.keyMap]) ++res.yes;
				// else res+="0";
				++res.max;
			});
			if (res.yes == 0) {
				this.option.status = "0";
				this.check = false;
				if (this.data) {
					this.$nextTick(() => {
						this.$emit("Empty", this.check);
					});
				}
			} else if (res.yes == res.max) {
				this.option.status = "2";
				this.check = true;
			} else if (res.yes > 0) {
				this.option.status = "1";
				this.check = false;
			}
			// }
		},
		onClick($event) {
			if ($($event.target).is("[href]")) {
				// 点击含有链接的元素进行跳转
				// window.open($(this.$el).find("[href]").attr("href"));
				let url = $($event.target).attr("href");
				let action = $($event.target).attr("target");
				if ((action = "_blank")) window.open(url);
				else this.$router.push(url);
			} else {
				// $event.stopPropagation()
				this.check = !this.check;
				if (this.data) {
					// 绑定了数据检测，自动进行全选和非全选
					let $this = this;
					$.each(this.data, function (key, value) {
						// if($this.option.status)
						// $this[key]=$this.check
						if (($this.max && key < $this.max - 1) || !$this.max) {
							$this.$set(value, $this.keyMap, $this.check);
						}
					});
					// this.updateStatus();
				}
				this.$emit("input", this.check, this.index >= 0 ? this.index : "all");
				this.$emit("Click", this.check, this.index >= 0 ? this.index : "all", this.checkObj);
				// this.$nextTick(()=>{
				// });
			}
		},
	},
	computed: {},
	mounted() {
		if (this.data) this.updateStatus();
	},
};
</script>
<style lang="scss" scoped>
.bgDisabeled {
	background: rgba(0, 0, 0, 0.04);
}
.checkbox {
	position: relative;
	display: inline-block;
	cursor: pointer;
	[type="checkbox"] {
		position: absolute;
		display: none;
	}
	.ico {
		position: relative;
		display: inline-block;
		width: 2rem;
		height: 2rem;
		vertical-align: middle;
		&:hover {
			border-color: $primary;
		}
		.fa {
			margin: {
				top: -0.9rem;
				left: -0.98rem;
			}
			position: absolute;
			top: 50%;
			left: 50%;
			display: block;
			transition-delay: 0.1s;
			transform: scale(0);
			@extend .fa;
		}
	}
	:checked + * > .ico .fa {
		transform: scale(1);
	}

	&[status] {
		.checked {
			position: absolute;
			top: 0;
			left: 0;
		}
	}
	&[status="0"] .checked {
		top: 50%;
		left: 50%;
		width: 0;
		height: 0;
	}
	&[status="1"] .checked {
		top: 50%;
		left: 50%;
		width: 50%;
		height: 50%;
		border-radius: 0.2em;
		margin: {
			top: -25%;
			left: -25%;
		}
	}
	&[status="2"] {
		.ico {
			//border-color:transparent;
			.fa {
				transform: scale(1);
			}
		}
		.checked {
			width: 100%;
			height: 100%;
		}
	}
	&.disable,
	.disable {
		cursor: default;
		// opacity: .25;
		// background: rgba(0,0,0,.04);
		border: rgba(0, 0, 0, 0.15);
	}

	//star
	&.checkbox-star {
		.ico {
			width: auto;
			height: auto;
			font-size: 1.6em;
			line-height: 0.6em;
			opacity: 0.2;
			&:before {
				content: "★";
			}
			&:after {
				display: none;
			}
		}
		:checked + * > .ico {
			opacity: 1;
		}
	}

	//onOff
	/*
	$onOffHeight:2em;
	&.checkbox-onOff{
		[type="checkbox"]+*{width:$onOffHeight * 2;height:$onOffHeight;border-radius:$onOffHeight;border:1px solid #e5e5e5;background-color:#fff;position:relative;transition-delay:.4s;
			&:before{content:"";@include size(100%);display:block;background-color:#fff;border-radius:$onOffHeight;@extend .tra;}
			&:after{content:"";@include size($onOffHeight - .2);display:block;background-color:#fff;border-radius:50%;position:absolute;top:0;left:0;box-shadow:0 .1em .5em rgba(#000,.4);@extend .tra;}
		}
		:checked+*{border:1px solid $green;background-color:$green;transition-delay:0s;
			&:before{transform:scale(0) translatex(50%);}
			&:after{left:$onOffHeight;}
		}
	}
	&.checkbox-onOff{
		[type="checkbox"]+*{width:$onOffHeight * 2;height:$onOffHeight;border-radius:$onOffHeight;background-color:rgba(#000,.2);position:relative;transition-delay:0;
			&:before{content:"";@include size($onOffHeight * 2 - .2,$onOffHeight - .2);display:block;background-color:#fff;border-radius:$onOffHeight;position:relative;top:.1em;left:.1em;@extend .tra;transition-delay:0;}
			&:after{content:"";@include size($onOffHeight - .2);display:block;background-color:#fff;border-radius:50%;position:absolute;top:.1em;left:.1em;box-shadow:0 .1em .5em rgba(#000,.4);@extend .tra;}
		}
		:checked+*{background-color:$green;transition-delay:0;
			&:before{width:0;margin:{left:80%;};transform:scale(0) translatex(50%);transition-delay:0;}
			&:after{left:$onOffHeight + .1;}
		}
	}
	*/
}
</style>



// WEBPACK FOOTER //
// src/components/common/ui/Checkbox.vue